import { Injectable } from '@angular/core';
import { API_URL } from '../../../../../../services/config';
import { WrapperHttpService } from '../../../../../services/wrapper-http-service';
import { AllocationViewEndpoint } from '../../constants';
import { AllocationViewActionIdentifierModel } from '../../models';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AllocationViewDeleteActionService {
  constructor(private http: WrapperHttpService) {}

  uliDelete(actionIdentifier: AllocationViewActionIdentifierModel): Observable<void> {
    const url = `${API_URL}${AllocationViewEndpoint.Action}${AllocationViewEndpoint.Uli}${AllocationViewEndpoint.Delete}`;

    return this.http.withLoading().post<void>(url, actionIdentifier);
  }
}
